import {Button, Col, Form, Row} from 'react-bootstrap'
import {RELATIONSHIP_OPTIONS} from '../../../helpers/catalogs'
import {INIT_FORM_MEMBERS} from '../../../helpers/policyFormDefaults'

type TMember = typeof INIT_FORM_MEMBERS

interface IProps {
  onPrev: () => void
  onNext: () => void
  members: TMember[]
  onChange: (index: number, field: string, value: string | boolean) => void
  onAdd: () => void
  onRemove: (index: number) => void
}

export const FamilyMembersTabModal: React.FC<IProps> = ({
  onPrev,
  onNext,
  members,
  onChange,
  onAdd,
  onRemove,
}) => {
  return (
    <div className='family-members-container'>
      <div className='kt-heading kt-heading--md custom-border-brand mb-5'>
        Applicants &amp; Dependents
      </div>

      {members.length === 0 && (
        <div className='text-center text-muted py-4 fst-italic'>
          No family members added yet.
        </div>
      )}

      {members.map((member, index) => (
        <div key={index} className='card mb-3 shadow-sm'>
          <div
            className='card-header d-flex justify-content-between align-items-center'
            style={{backgroundColor: '#f5f5ff'}}
          >
            <div className='d-flex align-items-center gap-2'>
              <i className='bi bi-person-fill text-primary' />
              <span className='fw-semibold'>
                {member.firstName || member.lastName
                  ? `${member.firstName} ${member.lastName}`.trim()
                  : `Member ${index + 1}`}
              </span>
              {member.dateBirth && (
                <span className='badge bg-light text-dark border ms-2' style={{fontSize: '11px'}}>
                  DOB: {member.dateBirth}
                </span>
              )}
              {member.gender && (
                <span className='badge bg-light text-dark border' style={{fontSize: '11px'}}>
                  {member.gender}
                </span>
              )}
            </div>
            <Button
              variant='outline-danger'
              size='sm'
              onClick={() => onRemove(index)}
            >
              <i className='bi bi-trash' />
            </Button>
          </div>

          <div className='card-body'>
            <Row className='mb-3'>
              <Col md={6}>
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  value={member.firstName}
                  onChange={(e) => onChange(index, 'firstName', e.target.value)}
                  placeholder='First name'
                />
              </Col>
              <Col md={6}>
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  value={member.lastName}
                  onChange={(e) => onChange(index, 'lastName', e.target.value)}
                  placeholder='Last name'
                />
              </Col>
            </Row>

            <Row className='mb-3'>
              <Col md={6}>
                <Form.Label>
                  Date of Birth
                  {member.dateBirth && (
                    <span className='text-success ms-2' style={{fontSize: '11px'}}>
                      <i className='bi bi-check-circle-fill' /> Pre-loaded
                    </span>
                  )}
                </Form.Label>
                <Form.Control
                  type='date'
                  value={member.dateBirth}
                  onChange={(e) => onChange(index, 'dateBirth', e.target.value)}
                />
              </Col>
              <Col md={6}>
                <Form.Label>
                  Gender
                  {member.gender && (
                    <span className='text-success ms-2' style={{fontSize: '11px'}}>
                      <i className='bi bi-check-circle-fill' /> Pre-loaded
                    </span>
                  )}
                </Form.Label>
                <Form.Select
                  value={member.gender}
                  onChange={(e) => onChange(index, 'gender', e.target.value)}
                >
                  <option value=''>-- Select --</option>
                  <option value='Male'>Male</option>
                  <option value='Female'>Female</option>
                </Form.Select>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Label>Relationship</Form.Label>
                <Form.Select
                  value={member.relationship}
                  onChange={(e) => onChange(index, 'relationship', e.target.value)}
                >
                  <option value=''>-- Select --</option>
                  {RELATIONSHIP_OPTIONS.map(({value, label}) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col md={6} className='d-flex align-items-end pb-1'>
                <Form.Check
                  type='switch'
                  id={`applicant-${index}`}
                  label='Applicant for coverage'
                  checked={member.applicant}
                  onChange={(e) => onChange(index, 'applicant', e.target.checked)}
                />
              </Col>
            </Row>
          </div>
        </div>
      ))}

      <div className='mt-3 mb-5'>
        <Button variant='success' size='sm' onClick={onAdd}>
          <i className='bi bi-plus' /> Add member
        </Button>
      </div>

      <div className='btn-prev-next'>
        <Button size='sm' variant='secondary' onClick={onPrev}>
          PREVIOUS
        </Button>
        <Button size='sm' onClick={onNext}>
          NEXT STEP
        </Button>
      </div>
    </div>
  )
}
